import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { ProgressBar, Button } from 'react-bootstrap';
import { isSaleLive, isUpcoming, Salediffernce, UpcomingDiffernce } from '../../hooks/useProjects';
import Countdown from 'react-countdown';
import coin from "../../images/coin.png";
import cardbanner from "../../images/chainpad/cardbanner.png";
import img1 from "../../images/img1.jpg";
import img2 from "../../images/img2.jpg";
import img3 from "../../images/img3.jpg";
import { CHAINS } from '../../config/env'
import { getAccount, getChainId, setChainId } from '../../hooks/useAccount'
import { UseTokenInfo, checkbalnceTokens } from '../../hooks/useContract';
import { getallsalehook, gettrendingdisplayhook, getuserdatahook, viewlisthook, wishlisthook, SaleLike, getSaleLikes } from '../../hooks/usebackend';
import tokencoin from "../../images/chainpad/coinss.png";
import pinimg from "../../images/chainpad/pinimg.png";
import { FaThumbsUp, FaThumbsDown } from 'react-icons/fa';
import Likemodal from "../likenotificationmodal";
import isEmpty from 'is-empty';

const renderer = ({ days, Month, Year, hours, minutes, seconds, completed }) => {
    if (completed) {
        return <div className='justify-content-center'>
            <div>{days}d </div>
            <div>{hours}h</div>
            <div>{minutes}m</div>
            <div>{seconds}s </div>
        </div>
    } else {
        // Render a countdown
        return <div>
            {/* <span>{days}<span>Days</span> </span>
                <span>{hours}<span>Hours</span></span>
                <span>{minutes}<span>Minuits</span></span>   
                <span>{seconds}<span>Seconds</span> </span>    */}
            <div>{days}d </div>
            <div>{hours}h</div>
            <div>{minutes}m</div>
            <div>{seconds}s </div>
        </div>;
    }
};

class LaunchpadBuycard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentChain: 0,
            wishlist: [],
            accountInfo: getAccount(),
            trending: [],
            singletrending: {},
            auditkyc: [],
            singleaudit: {},
            like: 0,
            dislike: 0,
            islike: null,
            likeCount: 0,
            dislikeCount: 0,
            likeStart: false,
            dislikeStart: false,
            likenotfiModal: false,
            buyTokenDecimal: 18,
            amount: 0,
            max: 0,
            isMax: false,
            buyToken: "",

        }
    }

    getuserdata = async () => {

        let userdata = await getuserdatahook(this.state.accountInfo.toLowerCase());
        console.log("userdata_buycard", userdata.data.data.likes, userdata?.data?.data);
        // this.setState({investedpools : userdata.data.data.investedpools})
        this.setState({ wishlist: userdata.data.data.wishlist })
        // this.setState({viewlist : userdata.data.data.viewlist})
        // this.setState({investedamount : userdata.data.data.investedamount})
        // let dollar = await Userdollar(userdata.data.data.investedamount);
        // this.setState({dollar : dollar});
        // this.handleactivities();

        let auditkycinfo = await getallsalehook();
        // this.setState({ likes: userdata?.data?.data?.likes })

        let likes = userdata?.data?.data?.likes
        likes.length > 0 && likes?.map((val) => {
            if (val.saleaddress == this?.props?.saleData?.saleAddress) {
                this.setState({ islike: val.islike })
            }
        })
        // console.log("auditkuycinfo", auditkycinfo?.data?.data);
        // if (auditkycinfo?.data?.data?.length > 0) {
        //     this.setState({ auditkyc: auditkycinfo?.data?.data })
        // }

        // let singleaudit = auditkycinfo?.data?.data?.find(e => e.saleaddress == this?.props?.saleData?.saleAddress)
        // if (singleaudit)
        //     this.setState({ singleaudit: singleaudit })
    }


    handlegetkyc = async () => {
        let auditkycinfo = await getallsalehook();
        if (auditkycinfo?.data?.data?.length > 0) {
          this.setState({ auditkyc: auditkycinfo?.data?.data })
        }
    
        let singleaudit = auditkycinfo?.data?.data?.find(e => e.saleaddress == this?.props?.saleData?.saleAddress)
        console.log("auditkuycinfo", auditkycinfo?.data?.data, singleaudit,this?.props?.saleData?.saleAddress);
    
        if (singleaudit)
          this.setState({ singleaudit: singleaudit })
      }


    componentDidMount() {
        this.setState({ currentChain: getChainId() });
        this.gettrending();
        this.GetBuytokeninfo()
        console.log("props", this.props.saleData);
        getAccount() && this.getuserdata();
        this.getLike()
        this.max()
        this.handlegetkyc()


    }


    componentWillReceiveProps(){
        this.handlegetkyc()
    }

  async GetBuytokeninfo(value) {
    try {
      if (value === "0x0000000000000000000000000000000000000000") {

        this.setState({ buyToken: "BNB" });
        this.setState({ buyTokenDecimal: 18 })
      } else {

        const token = await UseTokenInfo(this?.props?.saleData && this?.props?.saleData?.useWithToken);
        this.setState({ buyToken: token?.symbol });
        this.setState({ buyTokenDecimal: Number(token?.decimals) })

      }
    }
    catch (err) {
      console.log("err", err)
    }
  }


    async max() {
        this.setState({ max: this?.props?.saleData && (parseInt(this?.props?.saleData?.maxEthLimit) / 10 ** this.state.buyTokenDecimal), isMax: true })
        this.setState({ amount:this?.props?.saleData && (parseInt(this?.props?.saleData?.maxEthLimit) / 10 ** this.state.buyTokenDecimal) })
        // console.log("max",this.state.max,this.state.amount)
      }


    async getLike() {
        let likecount = await getSaleLikes(this?.props?.saleData?.saleAddress)
        if (likecount?.data?.type !== "failure") {
            console.log("likecount", likecount, this?.props?.saleData?.saleAddress)
            this.setState({ likeCount: likecount?.data?.data?.like, dislikeCount: likecount.data?.data?.dislike })
        }


    }


    async gettrending() {
        const { saleData } = this.props
        let data = await gettrendingdisplayhook();
        console.log("dataa trending", data?.data?.data);
        if (data?.data?.data?.length > 0)
            this.setState({ trending: data?.data?.data })
        let finddata = data?.data?.data?.find((e) => e?.saleaddress == saleData.saleAddress)
        this.setState({ singletrending: finddata })
    }


    // async GetBuytokeninfo() {
    //     try {
    //         const { saleData } = this.props
    //         if (saleData && saleData?.useWithToken === "0x0000000000000000000000000000000000000000") {
    //             this.setState({ buyToken: "BNB" });
    //         } else {
    //             console.log("saledaata info", saleData);
    //             const token = await UseTokenInfo(saleData && saleData?.useWithToken);
    //             console.log("tokeninfo", token);
    //             this.setState({ buyToken: token?.symbol });

    //         }
    //     }
    //     catch (err) {
    //         console.log("err", err)
    //     }
    // }

    // componentDidUpdate() {
    //     console.log("didupdarte");
    // }




    async handleheart() {
        console.log("handleheart");
        let account = getAccount();
        let payload = {
            walletaddress: account.toLowerCase(),
            saleaddress: this.props.saleData.saleAddress,
            chain: CHAINS[getChainId()].CHAIN_ID,
        }
        let wishlist = await wishlisthook(payload);
        console.log("wishlist respponsr", wishlist);
        this.setState({ wishlist: wishlist?.data?.data?.wishlist })
        this.getuserdata();
    }


    async hadleLike() {
        this.setState({ like: 1 })
        let account = getAccount();
        this.setState({ likeStart: !this.state.likeStart })
        this.setState({ dislikeStart: false })

        let data = {
            saleaddress: this?.props?.saleData?.saleAddress,
            walletaddress: account.toLowerCase(),
            like: 1,
            dislike: 0
        }
        var sales = await SaleLike(data)
        console.log("likesales", sales)
        let likes = sales?.data?.user?.likes
        likes?.map((val) => {
            if (val.saleaddress == this?.props?.saleData?.saleAddress) {
                this.setState({ islike: val.islike, likeCount: sales?.data?.result?.like, dislikeCount: sales?.data?.result?.dislike })
            }
        })
        console.log("likes", likes)
    }
    async hadledisLike() {
        this.setState({ dislike: 1 })
        let account = getAccount();
        this.setState({ dislikeStart: !this.state.dislikeStart })
        this.setState({ likeStart: false })



        let data = {
            saleaddress: this?.props?.saleData?.saleAddress,
            walletaddress: account.toLowerCase(),
            like: 0,
            dislike: 1
        }
        var sales = await SaleLike(data)
        console.log("dislikesales", sales)

        // this.setState({ likes: sales?.data?.user?.likes })
        // console.log("sales",sales)
        let likes = sales?.data?.user?.likes
        likes?.map((val) => {
            if (val.saleaddress == this?.props?.saleData?.saleAddress) {
                this.setState({ islike: val.islike, likeCount: sales?.data?.result?.like, dislikeCount: sales?.data?.result?.dislike })
            }
        })
        console.log("dislikes", likes)
    }


    lockDaysCal() {
        if (this.props?.saleData.lpUnlockon == 0) {
            return 0
        }
        console.log(this.props?.saleData.endTime, this.props?.saleData.lpUnlockon, "lockDaysCal")
        let diffTime = Math.abs(new Date(parseFloat(this.props?.saleData.endTime) * 1000).getTime() - new Date(parseFloat(this.props?.saleData.lpUnlockon) * 1000).getTime());
        let days = diffTime / (24 * 60 * 60 * 1000);
        console.log("days", days)
        return days.toFixed(0)
    }

    onDismiss() {
        this.setState({ likenotfiModal: false });
    }


    render() {

        const { saleData, tokenInfo } = this.props
        const { accountInfo, likenotfiModal } = this.state
        { console.log("saledatas_privatesale", saleData, tokenInfo); }
        return (
            <>
                {likenotfiModal && <Likemodal connect={"string"} onDismiss={() => this.onDismiss()} />}
                <div className='fullbrown col-12 col-xl-4 col-lg-4 col-md-6 col-lg-6-custom col-xxl-3 mt-3 mb-4 fined projects'>
                    {/* <a href={`/privatesaledetail/${saleData.saleAddress}`}> */}
                    <img src={pinimg} className='pinimg' alt='pinimg' />
                    <div className="btn-group btn_grp_yel mb-2 d-block d-xl-flex d-md-block d-sm-flex flex_cont_end_flex" role="group" aria-label="Basic example">

                        {/* <div className='d-sm-flex d-block mt-3 mt-xl-0 mt-md-3 mt-sm-0 text-right-xss'>
                            <p className=' mb-0'>
                                {saleData && isSaleLive(saleData.startTime, saleData.endTime, saleData.isPresaleOpen) ?

                                    <span className="badge badge_live badge_finish">

                                        <span className='stats_txt'>Sales Live</span>
                                    </span> :
                                    (saleData && isUpcoming(saleData.startTime) ?
                                        <span className="badge  badge_finish">


                                            <span className='stats_txt'>Upcoming</span>
                                        </span> :


                                        <span className="badge badge_finish">

                                            <span className='stats_txt'>Sales End</span>
                                        </span>
                                    )
                                }                              
                            </p>
                        </div> */}
                    </div>
                    <div className='first'>
                        <div className='second'>
                            <div className='finalss'>
                                <div className='card card_style_1 ribbox chainpadcard w-100'>
                                    {saleData && saleData.isWithoutToken ?
                                        <div className='ribbon'>NO TOKEN</div> : <></>
                                    }
                                    <div className='card-body'>
                                         <div className='position-relative'>
                                        <img src={saleData && saleData?.banner} className='img-fluid cardbanner' alt='banner' />
                                        <p className=' mb-0'>
                                {saleData && isSaleLive(saleData.startTime, saleData.endTime, saleData.isPresaleOpen) ?

                                    <span className="badge badge_live badge_finish">

                                        <span className='stats_txt d-flex align-items-center'><span className='roundclr mr-1'></span> Sales Live</span>
                                    </span> :
                                    (saleData && isUpcoming(saleData.startTime) ?
                                        <span className="badge  badge_finish">


                                            <span className='stats_txt'>Upcoming</span>
                                        </span> :


                                        <span className="badge badge_finish">

                                            <span className='stats_txt'>Sales End</span>
                                        </span>
                                    )
                                }                              
                            </p>
                                        </div>
                                        <div>

                                            {/* {this.state.auditkyc.find(e => e.saleaddress == this?.props?.saleData?.saleAddress) && 
                                        <p className='text-right'>
                                            <span className="badge badge-green-rect mt-0 mr-2">
                                                <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.audit} target="_blank">Audit</a>
                                            </span>
                                            <span className="badge badge-kyc-rect mt-0">
                                                <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.kyc} target="_blank">KYC</a>
                                            </span>
                                        </p>} */}
                                        </div>
                                        <div className='pt-0 px-3 pb-2'>
                                                 <div className='profimg'>
                                                    {console.log("saledataaaaaaaa", saleData?.logo)}
                                                    <img src={saleData && saleData?.logo} alt={saleData && saleData?.symbol} />
                                                </div>

                                            <div className='d-flex justify-content-between mt-2 mb-3'>

                                                {/* <img src={tokencoin} className='tokencoin' alt='tokencoin' /> */}
                                                {this.state.auditkyc.find(e => e.saleaddress == this?.props?.saleData?.saleAddress) &&
                                                    <div className='d-flex mt-4 ml-5'>
                                                         {console.log("audit",this.state.singleaudit.audit,this.state.singleaudit.kyc )}
                                                     {console.log("kyc",this.state.singleaudit.kyc )}
                                                        {!isEmpty(this.state.singleaudit.audit) ?  <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.audit} target="_blank"><p className='audit'>Audit</p></a>:""}
                                                        {!isEmpty(this.state.singleaudit.kyc) ? <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.kyc} target="_blank"><p className='audit ml-2'>KYC +</p></a>:""}
                                                    </div>}
                                            </div>


                                            <div  className='grid_img_div justify-content-between'>
                                                {/* <div className='profimg'>
                                                    {console.log("saledataaaaaaaa", saleData?.logo)}
                                                    <img src={saleData && saleData?.logo} alt={saleData && saleData?.symbol} />
                                                </div> */}
                                                <div className='ml-0'>
                                                    <span className='d-flex align-items-center'>
                                                        <span><p className='text-white cardtitle namefont font_19 mt-0 mb-0'>{saleData && saleData.name}</p></span>
                                                        <span className='ml-3'><button className='btn_social mr-2' onClick={() => { this.handleheart() }}>
                                                            <i class={this.state.wishlist.find(e => e.saleaddress == this.props?.saleData?.saleAddress) ? "fa fa-heart" : "fa fa-heart-o"} aria-hidden="true" ></i>
                                                        </button></span>
                                                    </span>
                                                
                                                    <div className='d-flex align-items-center gaps'>
                                                    <p className='mb-0 maxcont'>
                                                        {/* Max Contribution:  */}
                                                         {this.state.amount}  {saleData && saleData.symbol}
                                                          </p>
                                                          <div className='d-flex justify-content-center'>
                                                        {tokenInfo > 0 ?
                                                            <div className='thumpall'>
                                                                <Button variant="primary"
                                                                className='p-0'
                                                                    // disabled={tokenInfo > 0 ? this.state.islike == true ? true : false : true} 
                                                                    onClick={() => { this.hadleLike() }}>
                                                                    <FaThumbsUp className={this.state.likeStart == true ? "thumpupactive" : "thumpup"}

                                                                    />
                                                                    <span className='grnno ml-2'>{this.state.likeCount}</span>
                                                                </Button>
                                                            </div>
                                                            :
                                                            <div className='thumpall'>
                                                                <Button variant="primary" className='p-0' onClick={() => this.setState({ likenotfiModal: true })}>
                                                                    <FaThumbsUp className="thumpup" />
                                                                    <span className='grnno ml-2'>0</span>
                                                                </Button>
                                                            </div>
                                                        }


                                                        {tokenInfo > 0 ?
                                                            <div className='ml-3 thumpall'>
                                                                <Button variant="primary"
                                                                className='p-0'
                                                                    // disabled={tokenInfo > 0 ? this.state.islike == false ? true : false : true} 
                                                                    onClick={() => { this.hadledisLike() }}>
                                                                    <FaThumbsDown className={this.state.dislikeStart == true ? "thumpdownactive" : "thumpdown"} />
                                                                    <span className='redno ml-2'>{this.state.dislikeCount}</span>
                                                                </Button>
                                                            </div>
                                                            :
                                                            <div className='ml-3 thumpall'>
                                                                <Button variant="primary" className='p-0' onClick={() => this.setState({ likenotfiModal: true })}>
                                                                    <FaThumbsDown className="thumpdown" />
                                                                    <span className='redno ml-2'>0</span>
                                                                </Button>
                                                            </div>
                                                        }
                                                     
                                                    </div>
                                                    </div>
                                                </div>

                                              
                                                
                                         <div className='d-flex'>
                                                {this.state.auditkyc.find(e => e.saleaddress == this?.props?.saleData?.saleAddress) &&
                                                    <div className='d-flex'>
                                                         {console.log("audit",this.state.singleaudit.audit,this.state.singleaudit.kyc )}
                                                     {console.log("kyc",this.state.singleaudit.kyc )}
                                                        {!isEmpty(this.state.singleaudit.audit) ?  <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.audit} target="_blank"><p className='audit'>Audit</p></a>:""}
                                                        {!isEmpty(this.state.singleaudit.kyc) ? <a className='blk_txt text_in_badge_a' href={this.state.singleaudit.kyc} target="_blank"><p className='audit ml-2'>KYC +</p></a>:""}
                                                    </div>}
                                            </div>

                                           

                                                

                                            </div>


                                            {/* <p className='yellow_txt_sm'>{saleData && (saleData.description).substring(0,130)}...</p> */}



                                            {/* {this.state.singletrending && this.props.user && <span class="badge badge-kyc-rect mt-1 mb-2 badge_trend"><span class="blk_txt">#OnTop{this.state.singletrending?.position}</span></span>} */}




                                            {/* <p className='desc_grey_txt pb-0 mb-0'>1 {this.state.buyToken} = {saleData && (parseFloat(saleData.presaleRate)/10**18).toFixed(2)} {saleData && saleData.symbol}</p> */}



                                            {/* <p className=' text-gray mb-1 purple_head mt-2 font_13'>Softcap</p>
                <p className='green_txt_big pb-0 mb-0'>
                {saleData && (saleData.softCap / 10 ** 18).toFixed(2)} {this.state.buyToken}

                    </p> */}
                                            {/* {saleData && (saleData.hardCap/10**18).toFixed(2)} BNB */}

                                            <p className=' purple_head d-flex justify-content-between mt-2 mb-2'>
                                                <span className='desc_grey_txt progresss'>Progress
                                                    <span className='desc_grey_txt progresss ml-2 mr-2'>{saleData && parseInt(parseInt(saleData.earnedCap) / parseInt(saleData.hardCap) * 100)} %</span>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                                                        <path d="M11.408 13.1215H10.8658V8.79431C10.8658 8.60336 10.79 8.42022 10.6549 8.2852C10.5199 8.15017 10.3368 8.07431 10.1458 8.07431H8.04342C7.85247 8.07431 7.66933 8.15017 7.53431 8.2852C7.39928 8.42022 7.32342 8.60336 7.32342 8.79431C7.32342 8.98527 7.39928 9.1684 7.53431 9.30343C7.66933 9.43846 7.85247 9.51431 8.04342 9.51431H9.42582V13.1215H8.04342C7.85247 13.1215 7.66933 13.1974 7.53431 13.3324C7.39928 13.4674 7.32342 13.6506 7.32342 13.8415C7.32342 14.0325 7.39928 14.2156 7.53431 14.3506C7.66933 14.4857 7.85247 14.5615 8.04342 14.5615H11.408C11.5989 14.5615 11.7821 14.4857 11.9171 14.3506C12.0521 14.2156 12.128 14.0325 12.128 13.8415C12.128 13.6506 12.0521 13.4674 11.9171 13.3324C11.7821 13.1974 11.5989 13.1215 11.408 13.1215ZM9.72534 6.50831C9.93895 6.50831 10.1478 6.44497 10.3254 6.3263C10.503 6.20763 10.6414 6.03895 10.7231 5.84161C10.8049 5.64427 10.8263 5.42711 10.7846 5.21762C10.7429 5.00812 10.6401 4.81568 10.489 4.66464C10.338 4.5136 10.1455 4.41074 9.93604 4.36906C9.72654 4.32739 9.50939 4.34878 9.31204 4.43052C9.1147 4.51227 8.94603 4.65069 8.82735 4.8283C8.70868 5.0059 8.64534 5.21471 8.64534 5.42831C8.64534 5.71475 8.75913 5.98945 8.96167 6.19199C9.16421 6.39453 9.43891 6.50831 9.72534 6.50831ZM9.72534 0.738953C7.33921 0.741621 5.05158 1.69069 3.36433 3.37794C1.67708 5.06519 0.72801 7.35282 0.725342 9.73895C0.72934 12.1247 1.67884 14.4115 3.3658 16.0985C5.05276 17.7855 7.33962 18.735 9.72534 18.739C12.1123 18.739 14.4015 17.7907 16.0893 16.1029C17.7771 14.4151 18.7253 12.1259 18.7253 9.73895C18.7253 7.352 17.7771 5.06282 16.0893 3.37499C14.4015 1.68716 12.1123 0.738953 9.72534 0.738953ZM15.0029 15.1433C13.7541 16.36 12.1228 17.1072 10.3857 17.2582C8.6487 17.4091 6.91293 16.9545 5.47293 15.9714C4.03292 14.9883 2.97735 13.5373 2.48531 11.8646C1.99327 10.1919 2.09506 8.40048 2.77341 6.79427C3.45176 5.18806 4.66489 3.86598 6.20699 3.05235C7.74909 2.23871 9.52518 1.98362 11.2339 2.33035C12.9427 2.67708 14.4789 3.60428 15.5819 4.95465C16.6849 6.30501 17.2867 7.99537 17.2853 9.73895C17.2878 10.7469 17.087 11.7451 16.6948 12.6737C16.3026 13.6023 15.7272 14.4422 15.0029 15.1433Z" fill="#FFF" />
                                                    </svg>
                                                </span>
                                                {/* <span className='orangetext'>Participants<b className='pl-2'>{saleData && saleData.participants}</b></span> */}
                                                {console.log("saleDatasaleDatasaleData", parseFloat(parseInt(saleData?.earnedCap) / parseInt(saleData?.hardCap) * 100))}
                                            </p>
                                            <ProgressBar now={saleData && parseInt(parseInt(saleData?.earnedCap) / parseInt(saleData?.hardCap) * 100)} className='yellow_bar' />
                                            <p className='white_txt_sm d-flex justify-content-between mt-1'>

                                                {/* <span className='desc_grey_txt'>{saleData && ((saleData.earnedCap)/10**18).toFixed(3)}</span> */}
                                            </p>

                                            <div className='listheight'>
                                                <div className='row px-1 mb-2'>
                                                    <div className='col-6 col-md-6 mt-1'>
                                                        <div className='brownback'>
                                                        <span className='desc_grey_txt'>Softcap <span className='noclr'>{saleData && (saleData?.softCap / 10 ** 18).toFixed(2)} {this.state.buyToken}</span></span>
                                                   </div>
                                                    </div>
                                                    <div className='col-6 col-md-6 mt-1'>
                                                        <div className='brownback'>
                                                        {/* <span className='desc_grey_txt'>Users <span className='desc_grey_txt noclr font_12'>{saleData && saleData?.participants} </span></span> */}
                                                        <span className='desc_grey_txt'>Hardcap <span className='noclr'>{saleData && !isEmpty(saleData.hardCap) ? (saleData.hardCap / 10 ** 18).toFixed(2) : 0} {this.state.buyToken}</span></span>
</div>
                                                    </div>
                                                    {saleData && saleData?.isPancake ?
                                                        <>
                                                            <div className='col-6 col-md-6 mt-3'>
                                                                <div className='brownback'>
                                                                <span className='desc_grey_txt'>Swap Rate  <span className='desc_grey_txt noclr font_12'>{saleData && (saleData?.pancakeRate / 10 ** 18)}</span></span>
                                                           </div>
                                                            </div>

                                                            <div className='col-6 col-md-6 mt-3'>
                                                                <div className='brownback'>
                                                                <span className='desc_grey_txt'>Locked <span className='desc_grey_txt noclr font_12'>{saleData && isSaleLive(saleData.startTime, saleData.endTime, saleData.isPresaleOpen) == true || saleData?.isClaimable == false ?
                                                                    (saleData?.lpUnlockon * 1000) / (1000 * 60 * 60 * 24) : this.lockDaysCal()} Days</span></span>
                                                            </div>
                                                            </div>
                                                        </> : <></>}
                                                </div></div>

                                            {/* <p className='white_txt_sm d-flex justify-content-between mt-0 mb-1'>
               <span className='desc_grey_txt'>Total Users Participated:</span>
               <span className='desc_grey_txt font_12'>{saleData && saleData?.participants}</span>
                </p> */}

                                            {/* {saleData && saleData?.isPancake ? 
                <>
                <p className='white_txt_sm d-flex justify-content-between mt-0 mb-1'>
               <span className='desc_grey_txt'>Swap Rate:</span>
               <span className='desc_grey_txt font_12'>{saleData && saleData?.pancakeRate}</span>
                </p>

                <p className='white_txt_sm d-flex justify-content-between mt-0'>
               <span className='desc_grey_txt'>lockup Time :</span>
               <span className='desc_grey_txt font_12'>{saleData && (saleData?.lpUnlockon*1000)/(1000*60*60*24)} Days</span>
                </p>


                </> : <></>} */}


                                            {/* <hr className='hr_green' /> */}



                                         {/* new sales design */}
                                           {saleData && isUpcoming(saleData.startTime) ?
                                                                                           <div className='mainall'>
                                                                                           <button className="get-started-btn explore-btn ownbtn onebtn mt-3 mb-3 w-100">
                                                                                             <span>Starts in : </span> <span className='cflex ml-1'> <Countdown date={Date.now() + (UpcomingDiffernce(saleData.startTime))} renderer={renderer} className="countdown_grey" /></span>
                                                                                          </button> 
                                                                                           <a href={`/privatesaledetail/${saleData?.saleAddress}`} onClick={async () => {
                                                        localStorage.setItem("saledata", JSON.stringify(this.props?.saleData));
                                                        await this.handleview()
                                                    }}>
                                                                                           <button className="get-started-btn explore-btn hoverbtn twobtn mt-3 mb-3 w-100">
                                                                                              Add to Calendar
                                                                                          </button></a>
                                                                                          </div> 
                                                                                          :
                                                                                           <>
                                                                                           {saleData && isSaleLive(saleData.startTime, saleData.endTime, saleData.isPresaleOpen) ?
                                                                                           <div className='mainall'>
                                                                                           <button className="get-started-btn explore-btn ownbtn onebtn mt-3 mb-3 w-100">
                                                                                             <span className='greentxt livebg d-flex align-items-center mr-2'><div className='roundclr'></div>Live</span> <span>Ends : </span> <span className='cflex ml-1'> <Countdown date={Date.now() + Salediffernce(saleData.endTime)} renderer={renderer} className="countdown_grey" /></span>
                                                                                          </button> 
                                                                                           <a href={`/privatesaledetail/${saleData?.saleAddress}`} onClick={async () => {
                                                        localStorage.setItem("saledata", JSON.stringify(this.props?.saleData));
                                                        await this.handleview()
                                                    }}>
                                                                                           <button className="get-started-btn explore-btn hoverbtn twobtn mt-3 mb-3 w-100">
                                                                                              Explore
                                                                                          </button></a>
                                                                                          </div>                                            
                                                                                          :
                                          
                                                                                           <div className='mainall'>
                                                                                           <button className="get-started-btn explore-btn ownbtn onebtn mt-3 mb-3 w-100">
                                                                                              <span>Sale Is Ended </span> 
                                                                                              </button>
                                                                                           <a href={`/privatesaledetail/${saleData?.saleAddress}`} onClick={async () => {
                                                        localStorage.setItem("saledata", JSON.stringify(this.props?.saleData));
                                                        await this.handleview()
                                                    }}>
                                                                                           <button className="get-started-btn explore-btn hoverbtn twobtn mt-3 mb-3 w-100">
                                                                                              Claimed
                                                                                          </button></a>
                                                                                          </div>    }
                                                                                          </>
                                                                                            }
                                         
                                           {/* new sales design */}



                                         {/* old sales btn  */}
                                            {/* <div className='row justify-content-between'>
                                                <div className='col-6 col-md-6 mt-1'>
                                                    <div>
                                                        {saleData && isUpcoming(saleData.startTime) ?
                                                            <p class="mt-2 countup countbtn ml-sm-0 mb-2">
                                                                <span class="btn_timer">
                                                                    <div className='countdown'>
                                                                        <span className='desc_grey_txt'>Sale Starts in</span> <br /> <Countdown date={Date.now() + (UpcomingDiffernce(saleData.startTime))} renderer={renderer} className="countdown_grey" />
                                                                    </div>
                                                                </span>
                                                            </p> :
                                                            (saleData && isSaleLive(saleData.startTime, saleData.endTime, saleData.isPresaleOpen) ?
                                                                <p class="mt-2 countbtn mb-2">
                                                                    <span class="btn_timer">

                                                                        <span class="">
                                                                            <div className='countdown'>
                                                                                <span className='desc_grey_txt'>Sale Ends in</span> <br /> <Countdown date={Date.now() + Salediffernce(saleData.endTime)} renderer={renderer} className="countdown_grey" />
                                                                            </div>
                                                                        </span></span>
                                                                </p> :
                                                                <p className='countdown_grey mt-2'>
                                                                    <span className='desc_grey_txt'>The Sale Is Ended</span> <br />

                                                                </p>)
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-6 col-md-6 mt-2'>
                                                    
                                                    <a href={`/privatesaledetail/${saleData?.saleAddress}`} onClick={async () => {
                                                        localStorage.setItem("saledata", JSON.stringify(this.props?.saleData));
                                                        await this.handleview()
                                                    }}>
                                                        <button className="get-started-btn w-100 ml-0 explore-btn"
                                                        >
                                                          Explore
                                                        </button>
                                                    </a>
                                                </div>
                                            </div> */}


                                            {/* old sales btn end  */}  






                                            {/* <div className='white_txt_sm d-flex justify-content-between mt-0 align-items-center webr_res_div'>
                
                        <div className='pb_card_buy'>
                
                                             
                        </div>
                        </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </a> */}


                </div>
            </>
        )
    }

}


export default LaunchpadBuycard